// import { animate, scroll } from "motion";

const stickyNav = () => {
  let docScroll;
  const doc = document;

  const switchPos = 300;

  window.addEventListener('scroll', () => {
    
    docScroll = doc.documentElement.scrollTop;

    if ( docScroll > switchPos ) {
      doc.body.classList.add("is-scrolled");
    } else {
      doc.body.classList.remove("is-scrolled");
    }
    
  });




}


export { stickyNav as default };